import axios from 'axios';

export interface PortalUser {
  Oid: string;
  FirstName: string;
  LastName: string;
  UserName: string;
  IsActive: boolean;
  RelationOid: string;
  PortalRole: string;
  AuthorizedLocationOids: string[];
}

export interface CreatePortalUserData {
  FirstName: string;
  LastName: string;
  Email: string;
  Password: string;
  RelationOid: string;
  PortalRole: string;
  AuthorizedLocationOids: string[];
}

export interface UpdatePortalUserData {
  Oid: string;
  FirstName: string;
  LastName: string;
  IsActive: boolean;
  PortalRole: string;
  AuthorizedLocationOids: string[];
}

export async function getPortalUsers(relationOid: string, token: string): Promise<PortalUser[]> {
  const res = await axios.get(`/api/Authentication/PortalUsers?relationOid=${relationOid}`, getHeaders(token));
  return res.data;
}

export async function createPortalUser(data: CreatePortalUserData, token: string): Promise<PortalUser> {
  const res = await axios.post('/api/Authentication/CreatePortalUser', data, getHeaders(token));
  return res.data;
}

export async function updatePortalUser(data: UpdatePortalUserData, token: string): Promise<void> {
  await axios.put('/api/Authentication/UpdatePortalUser', data, getHeaders(token));
}

export async function deletePortalUser(oid: string, token: string): Promise<void> {
  await axios.delete(`/api/Authentication/DeletePortalUser/${oid}`, getHeaders(token));
}

export async function resetPortalUserPassword(oid: string, newPassword: string, token: string): Promise<void> {
  await axios.post('/api/Authentication/ResetPortalUserPassword', { Oid: oid, NewPassword: newPassword }, getHeaders(token));
}

const getHeaders = (token: string) => ({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});
